<template>
  <div class="bg-white rounded-lg shadow p-6 h-[500px] flex flex-col">
    <span class="text-sm text-gray-500"
      >Last Updated on: {{ lastUpdatedActivity }}</span
    >
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-lg font-medium text-gray-900">Activity Log (Last 50)</h3>
      <button
        class="text-gray-400 hover:text-gray-600"
        @click="$emit('filter-activities')"
      >
        <i class="material-icons">filter_list</i>
      </button>
    </div>

    <div class="space-y-4 overflow-y-auto flex-1">
      <div class="space-y-3">
        <ActivityItem
          v-for="activity in recentActivities"
          :key="activity.id"
          :activity="activity"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActivityItem from "./ActivityItem.vue";

export default {
  name: "ActivityLog",
  components: {
    ActivityItem
  },
  props: {
    recentActivities: {
      type: Array,
      default: () => []
    },
    yesterdayActivities: {
      type: Array,
      default: () => []
    },
    lastUpdatedActivity: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped>
.overflow-y-auto {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e0 #f7fafc;
}

.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: #f7fafc;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #cbd5e0;
  border-radius: 3px;
}
</style>
